import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import "handsontable/dist/handsontable.full.min.css";
import plusIcon from "../../../Assets/Images/FormCheck/plusIcon.png";
import { apiCall } from "../../../utils/axiosService";
import { API_URL } from "../../../utils/apiRoutes";
import { apiResponse } from "../../../utils/apiResponse";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setPropertyRateCount } from "../../../utils/slices/headerPropertySlice";
import deleteIcon from "../../../Assets/Images/Action Icons/deleteaction.svg";
import { commonService } from "../../../utils/commonService";
import DeleteItemModal from "../../Configuration/DeleteItemModal";
import AccessDenied from "../../CommonComponent/AccessDenied";
import searchIcon from "../../../Assets/Images/Configuration/search.svg";
import moment from "moment";
import { errorToastMessage } from "../../../utils/toastMessage";
import downloadIcon from "../../../Assets/Images/Operation/downloadIcon.svg";
import { HotTable } from "@handsontable/react";
import { registerAllModules } from "handsontable/registry";
import Loader from "../../Loader/Loader";

registerAllModules();

const RatePlan = ({ propertyDetail, saveAndNextBtn, showOnlyUnmapped = false, module }) => {

    let { id } = useParams();
    id = id || propertyDetail?.propertyid
    const dispatch = useDispatch();
    const referenceId = useRef();
    const hotTableComponent = useRef(null);
    const [ratePlanList, setRatePlanList] = useState();
    const searchRef = useRef(null);
    const [termList, setTermList] = useState(null);
    const termListRef = useRef(null);

    const [tableError, setTableError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const ratePlanRef = useRef();
    const ratePlanId = useRef();
    const changeRatePlanArr = useRef([]);
    const [listLoading, setListLoading] = useState(true);
    const [ImportLoading, setImportLoading] = useState(false);
    const inputFile = useRef();
    const [fileImportLoading, setFileImportLoading] = useState(false);
    const sortingRef = useRef({
        column: "",
        order: "",
    });
    if (ratePlanList) {
        ratePlanRef.current = [...ratePlanList];
    }

    const closeDeleteModal = () => {
        setDeleteModal(false);
    };

    const get_unmappedrate_plancode_data = async () => {
        let ratePlanListResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.RevenueManagement +
                    API_URL.REVENUE_RATE_PLAN.GET_UNMAPPEDRATE_PLANCODE_DATA,
                body: {
                    propertyid: parseInt(propertyDetail?.propertyid),
                },
            },
            false
        );
        let response = apiResponse(false, ratePlanListResponse);
        if (response?.isValidate) {
            const unmappedCount = response?.data?.data?.[0]?.unmapped || 0;
            localStorage.setItem("rateCounts", unmappedCount);
            dispatch(setPropertyRateCount(unmappedCount));
        }
    };

    const getRatePlanList = async () => {
        setListLoading(true);
        setRatePlanList(null);
        let ratePlanListResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.RevenueManagement +
                    API_URL.REVENUE_RATE_PLAN.GET_LIST,
                body: {
                    pageNum: 1,
                    pageSize: 10,
                    sortColumn: "",
                    sortDirection: "asc",
                    searchValue: "",
                    propertyid: parseInt(id),
                    ratecode: "",
                    ratecodetype_term: "",
                    marketsegment_term: "",
                    isbarbased: null,
                },
            },
            false
        );

        let response = apiResponse(false, ratePlanListResponse);

        if (response?.isValidate) {
            // setRatePlanList([...response?.data?.data, ...ratePlanListObj]);
            let updatedData = response?.data?.data?.map((item) => {
                if (
                    item.channelpartner === "" ||
                    item.channelpartner === null ||
                    item.channelpartner === undefined ||
                    item.channelpartner === "-"
                ) {
                    item.channelpartner = "Unmapped";
                }

                if (
                    item.marketsegment_term === "" ||
                    item.marketsegment_term === null ||
                    item.marketsegment_term === undefined ||
                    item.marketsegment_term === "-"
                ) {
                    item.marketsegment_term = "Unmapped";
                }
                return item;
            });

            if (showOnlyUnmapped) {
                let tmpUpdatedData = updatedData?.filter((item) => item?.marketsegment_term && item.marketsegment_term.toLowerCase() === "unmapped");
                // Bind only unmapped. 
                setRatePlanList(tmpUpdatedData ? tmpUpdatedData : []);
            } else {
                // Bind All. 
                setRatePlanList(updatedData ? updatedData : []);
            }
            setListLoading(false);
            await get_unmappedrate_plancode_data();
        }

        if (!response?.isValidate) {
            // setRatePlanList(ratePlanListObj);
            setRatePlanList([]);
            setListLoading(false);
        }

        // dataTable("propertyRatePlanTable");
    };

    const getTermList = async () => {
        let termListResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.Configuration +
                    API_URL.PROJECT_TERM.GET_LIST_BY_MULTIPLE_CATEGORY,
                body: {
                    categorynamebycomma: "Rate Code Type,Channel Type",
                },
            },
            false
        );

        let response = apiResponse(false, termListResponse);

        if (response?.isValidate) {
            termListRef.current = response?.data?.data;
            setTermList(response?.data?.data);
        }
    };

    const [termByPropertyList, setTermByPropertyList] = useState(null);
    const termByPropertyListRef = useRef(null);
    const getTermListByProperty = async () => {
        let termListResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.Configuration +
                    API_URL.PROJECT_TERM.GET_LIST_BY_MULTIPLE_CATEGORY_AND_PROPERTY,
                body: {
                    categorynamebycomma: "Market Segment",
                    propertyid: parseInt(id),
                },
            },
            false
        );

        let response = apiResponse(false, termListResponse);

        if (response?.isValidate) {
            termByPropertyListRef.current = response?.data?.data;
            setTermByPropertyList(response?.data?.data);
        }
    };

    //const handleChange = (changes, setRatePlanList) => {
    //    if (!changes) return;

    //    setRatePlanList((prev) => {
    //        const updated = [...prev];

    //        changes.forEach(([row, prop, oldValue, newValue]) => {
    //            if (updated[row]) {
    //                updated[row] = {
    //                    ...updated[row],
    //                    [prop]: newValue,
    //                };
    //            }
    //        });

    //        return updated;
    //    });
    //};

    const handleChange = (changes, source) => {
        if (!changes || source === "loadData") return;

        const hot = hotTableComponent.current?.hotInstance;
        if (!hot) return;

        setRatePlanList((prev) => {
            const updated = [...prev];

            changes.forEach(([visualRow, prop, oldValue, newValue]) => {
                // Convert Handsontable's visual row index to its physical index
                const physicalRow = hot.toPhysicalRow(visualRow);

                if (physicalRow == null || !updated[physicalRow]) return;

                updated[physicalRow] = {
                    ...updated[physicalRow],
                    [prop]: newValue,
                };
            });

            return updated;
        });
    };

    const handleSubmit = async () => {

        setLoading(true);
        const currentYear = moment().year();
        let payloadForSaveData = [];
        let validData = true;
        for (let i = 0; i < ratePlanList.length; i++) {
            let rateCodeValue = ratePlanList[i]?.ratecode?.trim() || "";
            let descriptionValue = ratePlanList[i]?.description?.trim() || "";
            let barBasedValue = ratePlanList[i]?.isbarbased ?? false;
            let ishouseaccountValue = ratePlanList[i]?.ishouseaccount ?? false;
            let rateCodeTypeValue = ratePlanList[i]?.ratecodetype_term?.trim() || "";
            let marketSegmentValue =
                ratePlanList[i]?.marketsegment_term?.trim() || "";
            let channelPartnerValue = ratePlanList[i]?.channelpartner?.trim() || "";
            let commission = ratePlanList[i]?.commission;

            // --- validation ---
            if (!rateCodeValue) {
                errorToastMessage("Enter Rate Code Value");
                validData = false;
                break;
            }
            if (!rateCodeTypeValue) {
                errorToastMessage("Select Valid Rate Code Type");
                validData = false;
                break;
            }
            if (!marketSegmentValue) {
                errorToastMessage("Select Valid Market Segment");
                validData = false;
                break;
            }
            if (!channelPartnerValue) {
                errorToastMessage("Select Valid Channel Partner");
                validData = false;
                break;
            }
            if (
                commission === "" ||
                commission === null ||
                isNaN(Number(commission))
            ) {
                errorToastMessage("Enter Valid Commision Value");
                validData = false;
                break;
            }

            // --- push to payload ---
            payloadForSaveData.push({
                rateplanid: ratePlanList[i]?.rateplanid || 0,
                propertyid: parseInt(id),
                propertycode: propertyDetail?.propertycode,
                ratecode: rateCodeValue,
                description: descriptionValue,
                isbarbased: barBasedValue,
                ratecodetype_term: rateCodeTypeValue,
                marketsegment_term: marketSegmentValue,
                updateon: commonService.getDateTimeInDBFormat(new Date()),
                year: ratePlanList[i]?.year ?? currentYear,
                channelpartner: channelPartnerValue,
                commission: Number(commission),
                ishouseaccount: ishouseaccountValue,

            });
        }

        if (!validData || payloadForSaveData.length === 0) {
            setLoading(false);
            return;
        }

        try {
            let saveResponse = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.RevenueManagement +
                        API_URL.REVENUE_RATE_PLAN.SAVE,
                    body: { data: payloadForSaveData },
                },
                true
            );

            let response = apiResponse(true, saveResponse, setLoading);
            if (response?.isValidate) {
                // await get_unmappedrate_plancode_data();
                await getRatePlanList();
                changeRatePlanArr.current = [];
                setTableError(null);
            }
        } finally {
            setLoading(false);
            setListLoading(false)
        }
    };

    const handleSearch = () => {
        let rateCodeSearchInput = document.getElementById("tblRateCode");
        let descriptionSearchInput = document.getElementById("tblDescription");
        let marketsegmentSearchInput = document.getElementById("tblMarketSegment");
        let channelPartnerSearchInput =
            document.getElementById("tblChannelPartner");
        let table = document.getElementById("propertyRatePlanTable");
        let tr = table.getElementsByTagName("tr");

        for (let i = 0; i < tr.length; i++) {
            let td = tr[i].getElementsByTagName("td");

            if (td?.length > 0) {
                let rateCodeTxtValue =
                    td?.[0]?.children?.[0]?.children?.[0]?.value || "";
                let descriptionTxtValue =
                    td?.[1]?.children?.[0]?.children?.[0]?.value || "";
                let marketsegmentTxtValue =
                    td?.[4]?.children?.[0]?.children?.[0]?.value || "";
                let channelPartnerTxtValue =
                    td?.[5]?.children?.[0]?.children?.[0]?.value || "";

                if (
                    rateCodeTxtValue
                        .toLowerCase()
                        .includes(rateCodeSearchInput?.value?.toLowerCase()) &&
                    descriptionTxtValue
                        .toLowerCase()
                        .includes(descriptionSearchInput?.value?.toLowerCase()) &&
                    marketsegmentTxtValue
                        .toLowerCase()
                        .includes(marketsegmentSearchInput?.value?.toLowerCase()) &&
                    channelPartnerTxtValue
                        .toLowerCase()
                        .includes(channelPartnerSearchInput?.value?.toLowerCase())
                ) {
                    tr[i].style.display = "";
                } else {
                    tr[i].style.display = "none";
                }
            }
        }
    };

    const handleSort = (n, trClassName) => {
        var table,
            rows,
            switching,
            i,
            x,
            y,
            shouldSwitch,
            dir,
            switchcount = 0;
        table = document.getElementById("propertyRatePlanTable");
        switching = true;
        dir = sortingRef.current.order;
        while (switching) {
            switching = false;
            rows = table.rows;

            for (i = 2; i < rows.length - 1; i++) {
                shouldSwitch = false;
                x =
                    rows[i].getElementsByTagName("TD")[n]?.children?.[0]?.children?.[0]
                        ?.value || "";
                y =
                    rows[i + 1].getElementsByTagName("TD")[n]?.children?.[0]
                        ?.children?.[0]?.value || "";

                if (dir == "asc") {
                    if (x.toLowerCase() > y.toLowerCase()) {
                        shouldSwitch = true;
                        break;
                    }
                } else if (dir == "desc") {
                    if (x.toLowerCase() < y.toLowerCase()) {
                        shouldSwitch = true;
                        break;
                    }
                }
            }
            if (shouldSwitch) {
                rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
                switching = true;
                switchcount++;
            } else {
                if (switchcount == 0 && dir == "asc") {
                    dir = "desc";
                    switching = true;
                }
            }
        }

        let upIconArr = document.querySelectorAll(".up-arrow-icon");
        for (let j = 0; j < upIconArr?.length; j++) {
            upIconArr?.[j]?.setAttribute("fill", "#DFDFDF");
        }

        let downIconArr = document.querySelectorAll(".down-arrow-icon");
        for (let j = 0; j < upIconArr?.length; j++) {
            downIconArr?.[j]?.setAttribute("fill", "#DFDFDF");
        }

        let upIcon = document.querySelectorAll(`.${trClassName} .up-arrow-icon`);
        let downIcon = document.querySelectorAll(
            `.${trClassName} .down-arrow-icon`
        );

        if (sortingRef.current.order === "asc") {
            upIcon?.[0].setAttribute("fill", "#000000");
            downIcon?.[0].setAttribute("fill", "#DFDFDF");
        } else {
            downIcon?.[0].setAttribute("fill", "#000000");
            upIcon?.[0].setAttribute("fill", "#DFDFDF");
        }
    };

    const callApi = async () => {
        await getTermList();
        await getTermListByProperty();
        getRatePlanList();
    };

    /*const handleFileUpload = async (file) => {*/
    const handleFileUpload = async (file) => {
        if (file) {
            setFileImportLoading(true);
            let fileUploadResponse = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.RevenueManagement +
                        API_URL.REVENUE_RATE_PLAN.FILE_UPLOAD,
                    body: {
                        file: file,
                    },
                },
                true
            );

            let response = apiResponse(false, fileUploadResponse);

            if (response?.isValidate) {
                setLoading(true);
                let dataFromApi = response?.data?.data;
                let payloadForSaveData = [];

                dataFromApi?.forEach((item) => {
                    var rateplanid = 0;
                    if (ratePlanList && ratePlanList.length > 0) {
                        var findELE = ratePlanList.filter((d) => d.ratecode === item?.ratecode.trim());
                        if (findELE && findELE.length > 0) {
                            var find_id = findELE[0].rateplanid;
                            if (find_id !== null && find_id !== "") {
                                rateplanid = parseInt(find_id);
                            }
                        }
                    }



                    payloadForSaveData.push({
                        rateplanid: rateplanid,
                        propertyid: parseInt(id),
                        propertycode: propertyDetail?.propertycode,
                        ratecode: item?.ratecode,
                        description: item?.description,
                        isbarbased: item?.barbased,
                        ratecodetype_term: item?.ratecodetype,
                        marketsegment_term: item?.marketsegment,
                        updateon: commonService.getDateTimeInDBFormat(new Date()),
                        year: new Date().getFullYear(),
                        channelpartner: item?.channelpartner,
                        commission: item?.commission,
                        ishouseaccount: item?.houseaccount,

                    });
                });
                let saveResponse = await apiCall(
                    {
                        method: "POST",
                        url:
                            API_URL.BASE_API_URL.RevenueManagement +
                            API_URL.REVENUE_RATE_PLAN.SAVE,
                        body: {
                            data: payloadForSaveData,
                        },
                    },
                    true
                );
                let responseFromSave = apiResponse(true, saveResponse, setLoading);
                if (responseFromSave?.isValidate) {
                    // await get_unmappedrate_plancode_data();
                    getRatePlanList();
                    setLoading(false);
                    changeRatePlanArr.current = [];
                }
                setFileImportLoading(false);
            }

            if (!response?.isValidate) {
                setFileImportLoading(false);
            }

            inputFile.current.value = "";
            inputFile.current.type = "text";
            inputFile.current.type = "file";
        } else {
            errorToastMessage("Please select file");
        }
    };

    useEffect(() => {
        callApi();
    }, [propertyDetail]);

    const fnImportRatePlansData = async () => {
        setImportLoading(true);

        var ratecodetype = [];
        var marketsegment = [];
        var channelpartner = [];

        if (termList) {
            var RCY = termList.filter((i) => i.termcategoryname === "Rate Code Type");
            var MS = termByPropertyList.filter(
                (i) => i.termcategoryname === "Market Segment"
            );
            var CT = termList.filter((i) => i.termcategoryname === "Channel Type");
            if (RCY) {
                RCY.map((item) => {
                    ratecodetype.push(item?.term);
                });
            }

            if (MS) {
                MS.map((item) => {
                    marketsegment.push(item?.term);
                });
            }

            if (CT) {
                CT.map((item) => {
                    channelpartner.push(item?.term);
                });
            }
        }

        let ratePlanListResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.RevenueManagement +
                    API_URL.REVENUE_RATE_PLAN.IMPORT_LIST,
                body: {
                    propertyid: parseInt(id),
                    ratecodetype: ratecodetype,
                    marketsegment: marketsegment,
                    channelpartner: channelpartner,
                },
            },
            false
        );

        let response = apiResponse(false, ratePlanListResponse);

        if (response?.isValidate) {
            setImportLoading(false);
            window
                .open(
                    API_URL.BASE_API_URL.RevenueManagement.replace("api/", "") +
                    response.data.data,
                    "_blank"
                )
                .focus();
        }

        if (!response?.isValidate) {
            setImportLoading(false);
        }
    };

    return commonService.checkUserPropertyRole(
        parseInt(id),
        module,
        "Property Rate Plans",
        "isview"
    ) ? (
        <div>
            <>
                <Row>
                    <Col xl={12}>
                        {!saveAndNextBtn && (
                            <div className="d-flex  mb-3">
                                {commonService.checkUserPropertyRole(
                                    parseInt(id),
                                    module,
                                    "Property Rate Plans",
                                    "iscreate"
                                ) && (
                                        <>
                                            <Col xl={6}>
                                                <div className="d-flex align-items-center">
                                                    <div
                                                        className={`special-btn-input-type-file ${fileImportLoading
                                                            ? "disable-special-btn-input-type-file"
                                                            : ""
                                                            }`}
                                                    >
                                                        <input
                                                            id="rateplan_import_file"
                                                            ref={inputFile}
                                                            type="file"
                                                            accept=".xlsx,.xls"
                                                            disabled={fileImportLoading}
                                                            style={{ maxWidth: "300px" }}
                                                        />
                                                    </div>
                                                    {fileImportLoading ? (
                                                        <button
                                                            className="add-btn-plus ms-1 me-1"
                                                            type="button"
                                                        >
                                                            <span
                                                                className="spinner-border spinner-border-sm"
                                                                role="status"
                                                                aria-hidden="true"
                                                            ></span>
                                                            Loading...
                                                        </button>
                                                    ) : (
                                                        <button id={commonService.generateGlobalClickTrackerID("RatePlan", "import", "")}
                                                            className="add-btn-plus ms-1 me-1"
                                                            type="button"
                                                            onClick={() => {
                                                                handleFileUpload(
                                                                    document.getElementById("rateplan_import_file")
                                                                        .files?.[0]
                                                                );
                                                            }}
                                                        >
                                                            <img src={plusIcon} alt="" /> Import
                                                        </button>
                                                    )}
                                                    {ImportLoading ? (
                                                        <button className="add-btn-plus" type="button">
                                                            <span
                                                                className="spinner-border spinner-border-sm"
                                                                role="status"
                                                                aria-hidden="true"
                                                            ></span>
                                                            Loading...
                                                        </button>
                                                    ) : (
                                                        <button id={commonService.generateGlobalClickTrackerID("RatePlan", "downloadIcon", "")}
                                                            className="add-btn-plus"
                                                            type="button"
                                                            onClick={() => {
                                                                fnImportRatePlansData();
                                                            }}
                                                        >
                                                            <img src={downloadIcon} alt="Download All Data" />{" "}
                                                            Export List
                                                        </button>
                                                    )}
                                                </div>
                                            </Col>
                                            <Col xl={6}>
                                                <div className="d-flex align-items-center justify-content-end">
                                                    <button id={commonService.generateGlobalClickTrackerID("RatePlan", "add-btn", "")}
                                                        className="add-btn-plus"
                                                        type="button"
                                                        onClick={() => {
                                                            referenceId.current
                                                                ? (referenceId.current += 1)
                                                                : (referenceId.current = 1);
                                                            setRatePlanList([
                                                                ...ratePlanRef.current,
                                                                {
                                                                    referenceId: referenceId.current,
                                                                    rateplanid: 0,
                                                                    propertyid: parseInt(id),
                                                                    propertycode: propertyDetail?.propertycode,
                                                                    ratecode: "",
                                                                    description: "",
                                                                    isbarbased: false,
                                                                    ratecodetype_term: "Low",
                                                                    marketsegment_term: "UNMAPPED",
                                                                    updateon: commonService.getDateTimeInDBFormat(
                                                                        new Date()
                                                                    ),
                                                                    year: 0,
                                                                    channelpartner: "UNMAPPED",
                                                                    ishouseaccount: false
                                                                },
                                                            ]);
                                                        }}
                                                    >
                                                        <img src={plusIcon} alt="" /> Add
                                                    </button>
                                                </div>
                                            </Col>
                                        </>
                                    )}
                            </div>
                        )}
                    </Col>
                    <Col xl={12}>
                        <div className="table__container">
                            <div className="stripped__table">
                                {
                                    listLoading ? (<div className="p-3">
                                        <Loader />
                                    </div>) :
                                        <HotTable
                                            ref={hotTableComponent}
                                            data={ratePlanList}
                                            search={true}
                                            stretchH="all"
                                            multiColumnSorting={{ indicator: true }}
                                            beforeColumnSort={(currentSortConfig, destinationSortConfigs) => {
                                                if (destinationSortConfigs.some(c => c.column === 7)) {
                                                    return false;
                                                }
                                            }}
                                            colHeaders={[
                                                "RATE CODE",
                                                "DESCRIPTION",
                                                "BAR BASED",
                                                "HOUSE ACCOUNT",
                                                "RATE CODE TYPE",
                                                "MARKET SEGMENT",
                                                "CHANNEL PARTNER",
                                                "COMMISSION",
                                                "ACTION",
                                            ]}
                                            columns={[
                                                { data: "ratecode", type: "text" },
                                                { data: "description", type: "text" },
                                                { data: "isbarbased", type: "checkbox" },
                                                { data: "ishouseaccount", type: "checkbox" },
                                                {
                                                    data: "ratecodetype_term",
                                                    type: "dropdown",
                                                    source: termListRef.current
                                                        ?.filter((t) => t.termcategoryname === "Rate Code Type")
                                                        .map((t) => t.term.toUpperCase()),
                                                },
                                                {
                                                    data: "marketsegment_term",
                                                    type: "dropdown",
                                                    source: termByPropertyListRef.current
                                                        ?.filter((t) => t.termcategoryname === "Market Segment")
                                                        .map((t) => t.term.toUpperCase()),
                                                },
                                                {
                                                    data: "channelpartner",
                                                    type: "dropdown",
                                                    source: termListRef.current
                                                        ?.filter((t) => t.termcategoryname === "Channel Type")
                                                        .map((t) => t.term.toUpperCase()),
                                                },
                                                {
                                                    data: "commission",
                                                    type: "numeric",
                                                    numericFormat: { pattern: "0,0.00" },
                                                },
                                                {
                                                    data: "action",
                                                    renderer: function (instance, td, row) {
                                                        // Clear previous content
                                                        td.innerHTML = "";

                                                        // Create img element
                                                        const img = document.createElement("img");
                                                        img.src = deleteIcon;
                                                        img.alt = "Delete";
                                                        img.style.cursor = "pointer";
                                                        img.style.width = "18px"; // adjust size
                                                        img.style.height = "18px";
                                                        img.onclick = () => {
                                                            /*const rowData = instance.getSourceDataAtRow(row);*/
                                                            const physicalRow = instance.toPhysicalRow(row);
                                                            const rowData = instance.getSourceDataAtRow(physicalRow);

                                                            if (rowData.rateplanid > 0) {
                                                                ratePlanId.current = rowData.rateplanid;
                                                                setDeleteModal(true);
                                                            } else {
                                                                let updatedData = ratePlanRef.current?.filter(
                                                                    (x) => x.referenceId !== rowData.referenceId
                                                                );

                                                                let changeRatePlanArrUpdatedData =
                                                                    changeRatePlanArr.current?.filter(
                                                                        (x) => x.referenceId !== rowData.referenceId
                                                                    );

                                                                changeRatePlanArr.current =
                                                                    changeRatePlanArrUpdatedData;
                                                                setRatePlanList(updatedData);

                                                                setTableError(null);
                                                            }
                                                        };

                                                        // Append image to cell
                                                        td.appendChild(img);
                                                    },
                                                },
                                            ]}
                                            cells={(row, col) => {
                                                if (col === 0) {
                                                    const cellProperties = {};

                                                    cellProperties.className = "custom-td";

                                                    cellProperties.renderer = (
                                                        instance,
                                                        td,
                                                        row,
                                                        col,
                                                        prop,
                                                        value
                                                    ) => {

                                                        const physicalRow = instance.toPhysicalRow(row);
                                                        const rowData = instance.getSourceDataAtRow(physicalRow);

                                                        td.setAttribute(
                                                            "rateplanid",
                                                            rowData?.rateplanid || ""
                                                        );

                                                        td.setAttribute(
                                                            "ratecode",
                                                            rowData?.ratecode || ""
                                                        );

                                                        td.innerText = value ?? "";
                                                    };

                                                    return cellProperties;
                                                }

                                                if (col === 7) {
                                                    return {
                                                        filter: false,
                                                        dropdownMenu: false,
                                                    };
                                                }
                                            }}
                                            rowHeaders={false}
                                            height={showOnlyUnmapped ? "calc(100vh - 190px)" : "calc(100vh - 320px)"}
                                            manualColumnResize={false}
                                            manualRowResize={false}
                                            filters={true}
                                            dropdownMenu={[
                                                "filter_operators",
                                                // "filter_by_condition",
                                                "filter_by_value",
                                                "filter_action_bar",
                                            ]}
                                            width={"100%"}
                                            colWidths={(index) => {
                                                const totalWidth = hotTableComponent.current?.hotInstance?.rootElement?.clientWidth || window.innerWidth - 100;
                                                const widths = [
                                                    0.10, 0.14, 0.07, 0.10, 0.10, 0.10, 0.08, 0.04,
                                                ];
                                                return totalWidth * widths[index];
                                            }}
                                            afterGetColHeader={(col, TH) => {
                                                if (col === 7) {
                                                    const dropdownButton = TH.querySelector(".changeType");
                                                    if (dropdownButton) {
                                                        dropdownButton.style.display = "none";
                                                    }
                                                }
                                            }}
                                            licenseKey="non-commercial-and-evaluation"
                                            afterChange={(changes, source) => {
                                                handleChange(changes, source);
                                            }}
                                        //afterChange={(change) => {
                                        //    handleChange(change, setRatePlanList);
                                        //}}
                                        />
                                }
                            </div>
                        </div>
                    </Col>
                    <Col xl={12}>
                        <div className="d-flex align-items-center justify-content-end mt-3 fixed-button-bottom">
                            {loading ? (
                                <button
                                    className="default-btn primary-btn"
                                    type="button"
                                    disabled
                                >
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                    Loading...
                                </button>
                            ) : saveAndNextBtn ? (
                                commonService.checkUserPropertyRole(
                                    parseInt(id),
                                    module,
                                    "Property Rate Plans",
                                    "iscreate"
                                ) && (
                                    <>
                                        <Button id={commonService.generateGlobalClickTrackerID("RatePlan", "save-and-next", "")}
                                            className="default-btn primary-btn"
                                            onClick={() => {
                                                handleSubmit();
                                            }}
                                        >
                                            Save And Next
                                        </Button>
                                    </>
                                )
                            ) : (
                                commonService.checkUserPropertyRole(
                                    parseInt(id),
                                    module,
                                    "Property Rate Plans",
                                    "iscreate"
                                ) && (
                                    <Button id={commonService.generateGlobalClickTrackerID("RatePlan", "submit", "")}
                                        className="default-btn primary-btn"
                                        onClick={() => {
                                            handleSubmit();
                                        }}
                                    >
                                        Submit
                                    </Button>
                                )
                            )}
                        </div>
                    </Col>
                </Row>
            </>
            {deleteModal && (
                <DeleteItemModal
                    showDeleteItemModal={deleteModal}
                    closeDeleteItemModal={closeDeleteModal}
                    id={ratePlanId.current}
                    getList={getRatePlanList}
                    url={
                        API_URL.BASE_API_URL.RevenueManagement +
                        API_URL.REVENUE_RATE_PLAN.DELETE
                    }
                />
            )}
        </div>
    ) : (
        <AccessDenied />
    );
};

export default RatePlan;
